import { render } from "./CartaPropostaEmDigitacao.vue?vue&type=template&id=729fe7e9&scoped=true"
import script from "./CartaPropostaEmDigitacao.vue?vue&type=script&lang=js"
export * from "./CartaPropostaEmDigitacao.vue?vue&type=script&lang=js"

import "./CartaPropostaEmDigitacao.vue?vue&type=style&index=0&id=729fe7e9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-729fe7e9"]])

export default __exports__